import { ACTIONS } from '@/utils/constants/gaCustomEventSet'
import { FOOTER_TAB_AB_TEST_NAME } from './abTestConfig'

export const AB_TEST_GA_EVENT_TARGETS = {
  // SIMILAR_EVENT_GROUP_AB_TEST GA Target Events
  CLICK_SEARCH_EVENT_LIST_ITEM: 'click_search_event_list_item',
  CLICK_SEARCH_SIMILAR_EVENT_GROUP: 'click_search_similar_event_group',
  VIEW_SEARCH: 'view_search_page',

  // EVENT_DETAIL_TOAST_AB_TEST GA Target Events
  CLICK_EVENT_DETAIL_PURCHASE: 'click_event_detail_purchase',

  // FOOTER_TAB_AB_TEST GA Target Events
  AB_GROUP_ALLOCATION: 'ab_group_allocation'

  // Need to add or remove target events when needed
} as const

export type AB_TEST_GA_EVENT_TARGET = (typeof AB_TEST_GA_EVENT_TARGETS)[keyof typeof AB_TEST_GA_EVENT_TARGETS]

export type ABTestGAEvent = {
  target_event: AB_TEST_GA_EVENT_TARGET
  action: string
  Alabel?: string
  Blabel?: string
}

export type ABTestGAEventItem = {
  ab_test_name: string
  category: string
  events: ABTestGAEvent[]
}

export const ABTestGAEventList: ABTestGAEventItem[] = [
  {
    ab_test_name: 'SIMILAR_EVENT_GROUP_AB_TEST',
    category: '同じイベント問題解決abtest',
    events: [
      {
        target_event: AB_TEST_GA_EVENT_TARGETS.CLICK_SEARCH_EVENT_LIST_ITEM,
        action: ACTIONS.CLICK,
        Alabel: 'a_archive_component_202502',
        Blabel: 'b_archive_component_202502'
      },
      {
        target_event: AB_TEST_GA_EVENT_TARGETS.CLICK_SEARCH_SIMILAR_EVENT_GROUP,
        action: ACTIONS.CLICK,
        Blabel: 'archive_anotherdaylink_202502'
      },
      {
        target_event: AB_TEST_GA_EVENT_TARGETS.VIEW_SEARCH,
        action: ACTIONS.VIEW,
        Alabel: 'a_archive_component_view_202502',
        Blabel: 'b_archive_component_view_202502'
      }
    ]
  },
  {
    ab_test_name: 'EVENT_DETAIL_TOAST_AB_TEST',
    category: 'このイベントには◯人が訪れました改修abtest',
    events: [
      {
        target_event: AB_TEST_GA_EVENT_TARGETS.CLICK_EVENT_DETAIL_PURCHASE,
        action: ACTIONS.CLICK,
        Alabel: 'a_visited_2025',
        Blabel: 'b_visited_2025'
      }
    ]
  },
  {
    ab_test_name: FOOTER_TAB_AB_TEST_NAME,
    category: 'issue248',
    events: [
      {
        target_event: AB_TEST_GA_EVENT_TARGETS.AB_GROUP_ALLOCATION,
        action: ACTIONS.AB_GROUP_ALLOCATION,
        Alabel: 'group_a',
        Blabel: 'group_b'
      }
    ]
  }
]
